import appBlockIcon from '~/assets/images/benefits/app-block.svg'
import customAppAllowListIcon from '~/assets/images/benefits/custom-app-allow-list.svg'
import focusTrendAnalysisIcon from '~/assets/images/benefits/focus-trend-analysis.svg'
import freeUseCrystalTreeIcon from '~/assets/images/benefits/free-use-crystal-tree.svg'
import plantTreeForEarthIcon from '~/assets/images/benefits/plant-tree-for-earth.svg'
import plusExclusiveTreeIcon from '~/assets/images/benefits/plus-exclusive-tree.svg'
import seasonalCrystalTreesIcon from '~/assets/images/benefits/seasonal-crystal-trees.svg'
import tripleCoinRewardPremiumIcon from '~/assets/images/benefits/triple-coin-reward-premium.svg'
import tripleCoinRewardIcon from '~/assets/images/benefits/triple-coin-reward.svg'
import { m } from '~/paraglide/messages'

export interface BenefitItem {
  icon: string
  label: () => string
}

// Item sets and ordering follow the Figma "Pass paywall" designs:
// non-premium 22971:50911, premium 22981:141268 (Focus Pass Events).
const freeUserBenefits: BenefitItem[] = [
  { icon: customAppAllowListIcon, label: m.custom_app_allow_list },
  { icon: freeUseCrystalTreeIcon, label: m.free_use_crystal_tree },
  { icon: focusTrendAnalysisIcon, label: m.focus_trend_analysis },
  { icon: plantTreeForEarthIcon, label: m.plant_tree_for_earth },
  { icon: tripleCoinRewardIcon, label: m.triple_coin_reward },
  { icon: appBlockIcon, label: m.app_block },
]

const premiumUserBenefits: BenefitItem[] = [
  { icon: appBlockIcon, label: m.app_block },
  { icon: plusExclusiveTreeIcon, label: m.plus_exclusive_tree },
  { icon: seasonalCrystalTreesIcon, label: m.seasonal_crystal_trees },
  { icon: tripleCoinRewardPremiumIcon, label: m.triple_coin_reward },
]

export function getBenefitItems(isPremium: boolean): BenefitItem[] {
  return isPremium ? premiumUserBenefits : freeUserBenefits
}
